/**
 * 检测是否为 iOS 设备
 * @returns {Boolean} true: iOS设备，false: 非iOS设备
 */
export function isIOS() {
  const userAgent = navigator.userAgent.toLowerCase();
  // 匹配 iOS 设备的核心特征：包含 iphone/ipad/ipod 且排除微信内置浏览器的特殊标识（可选）
  return /iphone|ipad|ipod/.test(userAgent) && !/windows phone/.test(userAgent);
}

/**
 * 非 iOS 设备提示并拦截页面
 */
export function checkIOSDevice() {
  // 检查配置开关，如果禁用检测则直接返回true
  if (window.appConfig && window.appConfig.iosDeviceCheckEnabled === false) {
    return true;
  }
  if (!isIOS()) {
    // 跳转到 public 目录下的提示页（打包后路径不变）
    window.location.href = '/error.html';
    // 阻止后续代码执行
    return false;
  }
  return true;
}